import React, { useEffect } from 'react';

const AccessibilityStatement: React.FC = () => {
    useEffect(() => {
        document.title = 'הצהרת נגישות - חיים פלוס';
    }, []);

    return (
        <div className="container accessibility-statement-page">
            <a href="#main-content" className="skip-link">דלג לתוכן הראשי</a>
            <header>
                <div className="logo">
                    <img
                        src="/assets/life-logo.svg"
                        alt="חיים פלוס"
                    />
                </div>
            </header>
            <main id="main-content">
                <div className="accessibility-content">
                    <h1>הצהרת נגישות</h1>
                    
                    <p>
                        אנו רואים חשיבות רבה בהנגשת האתר לכלל האוכלוסייה, ובפרט לאנשים עם מוגבלויות.
                        האתר הונגש בהתאם להוראות חוק שוויון זכויות לאנשים עם מוגבלות, ולתקן הישראלי ת״י 5568, המבוסס על הנחיות WCAG 2.1 ברמה AA.
                    </p>

                    <h2>אמצעי נגישות באתר</h2>
                    
                    <p>באתר זה יושמו, בין היתר, ההתאמות הבאות:</p>
                    
                    <ul>
                        <li>התאמה לגלישה באמצעות מקלדת</li>
                        <li>תמיכה בטכנולוגיות מסייעות (כגון קוראי מסך)</li>
                        <li>שימוש בניגודיות צבעים מתאימה</li>
                        <li>אפשרות להגדלת טקסט בעזרת זום הדפדפן</li>
                        <li>מבנה תוכן ברור והיררכי</li>
                        <li>טקסטים חלופיים לתמונות (alt)</li>
                    </ul>

                    <h2>תאימות דפדפנים ומכשירים</h2>
                    
                    <p>
                        האתר מותאם לשימוש בדפדפנים הנפוצים (Chrome, Firefox, Edge, Safari) ולגלישה ממחשב, טאבלט ומכשיר נייד.
                    </p>

                    <h2>מגבלות נגישות</h2>
                    
                    <p>
                        ייתכן שחלקים מסוימים באתר טרם הונגשו באופן מלא או שאינם תואמים במלואם לתקן. אנו ממשיכים לפעול לשיפור נגישות האתר ככל שניתן.
                    </p>

                    <h2>פרטי אחראי נגישות</h2>
                    
                    <p>
                        שם: ____________<br />
                        טלפון: ____________<br />
                        דוא״ל: ____________
                    </p>

                    <h2>פניות בנושא נגישות</h2>
                    
                    <p>
                        אם נתקלת בבעיה כלשהי בנושא נגישות באתר, נשמח לקבל פנייה ולפעול לתיקון הבעיה בהקדם.
                        אנא ציין:
                    </p>
                    
                    <ul>
                        <li>תיאור הבעיה</li>
                        <li>כתובת העמוד בו נתקלת בבעיה</li>
                        <li>סוג הדפדפן והמכשיר</li>
                    </ul>

                    <h2>תאריך עדכון הצהרת הנגישות</h2>
                    
                    <p>
                        הצהרה זו עודכנה לאחרונה בתאריך: //____
                    </p>
                </div>
            </main>
        </div>
    );
};

export default AccessibilityStatement;

